/**
 * 서버 detail 을 토스트에 그대로 넣기 전에 한글인지 가린다.
 * 영문·JSON·빈 값은 버리고, 한글이 한 글자라도 있으면 엔진이 준 안내로 본다.
 */
export const koreanOrNull = (value) => (
  typeof value === 'string' && /[가-힣]/.test(value) ? value : null
);
